import React, { useState, useEffect, useCallback } from "react";
import { CircularProgress, Box, Typography, Grid } from "@mui/material";
import PlanosCard from "../PlanosCard";
import { API_URLS } from "../../config/apiUrls";

interface Plano {
  id: string;
  name: string;
  description: string;
  price: string;
  duration: number;
  isActive: boolean;
  startsAt: string | null;
  endsAt: string | null;
  limitPerUser: number | null;
}

interface PlanosListaProps {
  token: string;
  shouldUpdateList: boolean;
}

const PlanosLista: React.FC<PlanosListaProps> = ({
  token,
  shouldUpdateList,
}) => {
  const [planos, setPlanos] = useState<Plano[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPlanos = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URLS.planos}/admin/all`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (!response.ok) {
        throw new Error("Erro ao buscar os planos");
      }
      const data = await response.json();
      setPlanos(data);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchPlanos();
  }, [fetchPlanos, shouldUpdateList]);

  if (loading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100vh"
      >
        <Typography color="error">{error}</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Planos Disponíveis
      </Typography>
      <Grid container spacing={3}>
        {planos.map((plano) => (
          <PlanosCard
            key={plano.id}
            id={plano.id}
            name={plano.name}
            description={plano.description}
            price={plano.price}
            duration={plano.duration}
            isActive={plano.isActive}
            startsAt={plano.startsAt}
            endsAt={plano.endsAt}
            limitPerUser={plano.limitPerUser}
            token={token}
            onPlanUpdate={fetchPlanos} // Passando a função de recarregar a lista
          />
        ))}
      </Grid>
    </Box>
  );
};

export default PlanosLista;
